export default __webpack_public_path__ + "static/media/761.f370b1f6.png";